exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".button-placeholder{padding-top:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-cc49fc46!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductStationaryAvailability/StationaryShop.vue
// module id = 935
// module chunks = 2